import { Menu, X } from "lucide-react";
import { usePathname } from "next/navigation";

interface BurgerMenuProps {
    isOpen: boolean;
    toggleMenu: () => void;
    currentTheme: string | undefined;
    scrolled: boolean;
    isSmallScreen?: boolean;
    shouldHaveBackground?: boolean;
}

const BurgerMenu: React.FC<BurgerMenuProps> = ({
    isOpen,
    toggleMenu,
    currentTheme,
    scrolled,
    isSmallScreen,
    shouldHaveBackground,
}) => {
    const pathname = usePathname();
    const isBookingPage = pathname === "/booking" || pathname === "/vehicle";
    const isHomePage = pathname === "/";

    // Calcul initial pour déterminer si l'icône doit être sombre
    const shouldUseDarkIcon =
        currentTheme !== "dark" && (scrolled || (isSmallScreen && isOpen || shouldHaveBackground && isOpen));
    // const shouldHaveBackground = scrolled || (isMobile && isMenuOpen || isMobileScreen && shouldHaveBackground) || isBookingPage

    // Si on est sur la page booking, on force la couleur à "text-text"
    const finalIconColor = isBookingPage ? "text-text" : shouldHaveBackground ? "text-text" : "text-background_sd";

    return (
        <button onClick={toggleMenu} className="lg:hidden" aria-label="Toggle menu">
            {isOpen ? (
                <X className={`transition-colors duration-300 ${finalIconColor}`} />
            ) : (
                <Menu className={`transition-colors duration-300 ${finalIconColor}`} />
            )}
        </button>
    );
};

export default BurgerMenu;
